import Header from '../Header';
import { MainWrapper } from '../../../styles/chime-react/CommonStyles';
import { ReactElement, useEffect } from 'react';
import { useInternalSession } from '../../../providers/SessionProvider';

const NoneLayout = ({
  page,
  showGreeting,
  hideUserName,
  showStripedBackground,
  disableMainLink
}: {
  page: ReactElement;
  /** ヘッダーの「へようこそ！」の文言を表示するかどうか */
  showGreeting?: boolean;
  /** ストライクの背景を表示するかどうか */
  showStripedBackground?: boolean;
  /** 「会社名・スタッフ名」を非表示にするかどうか */
  hideUserName?: boolean;
  /** ロゴのリンクは無効化どうか */
  disableMainLink?: boolean;
}) => {
  const { status } = useInternalSession();
  const isAuthenticated = status === 'authenticated';

  useEffect(() => {
    if (showStripedBackground) {
      document.documentElement.classList.add('striped-bg');
    } else {
      document.documentElement.classList.remove('striped-bg');
    }

    return () => {
      document.documentElement.classList.remove('striped-bg');
    };
  }, [showStripedBackground]);

  return (
    <>
      <Header
        showGreeting={showGreeting}
        hideUserName={hideUserName}
        disableMainLink={disableMainLink}
        isLoggedIn={isAuthenticated}
      />
      <MainWrapper isLoggedIn={!hideUserName && isAuthenticated}>
        {page}
      </MainWrapper>
    </>
  );
};

export default NoneLayout;
